import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Formatter from './formatter'
import { enLocale } from './locales/en-EN'
import { ruLocale } from './locales/ru-RU'


Vue.use(VueI18n)

// Читаем сохраненный язык из localStorage или используем значение по умолчанию
const getSavedLocale = () => {
  const savedLocale = localStorage.getItem('app-locale')
  // Проверяем, что сохраненный язык поддерживается
  if (savedLocale === 'en-US' || savedLocale === 'ru-RU') {
    return savedLocale
  }
  return 'en-US' // default locale
}

const locale = getSavedLocale()
const formatter = new Formatter({ locale })

export default new VueI18n({
  locale,
  formatter,
  messages:   {
    'en-US': enLocale,
    'ru-RU': ruLocale
  } 
})
